import { useEffect, useState } from 'react';

/**
 * Lightweight debounce hook. Returns a value that lags `delay` ms behind the
 * input. Used to throttle server-side search queries on paginated list pages.
 */
export const useDebounce = (value, delay = 350) => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
};
